import { useEffect, useState } from "react";

import { Button, Typography } from "@mui/material";

import CurrentSession from "data/userSession";
import useCustomNavigation from "hooks/customNavigation";
import ProfilePicture from "features/user/ProfilePicture";

interface LogoProps {
  user?: { uid?: string } | null;
}

const Logo = ({ user }: LogoProps) => {
  const navigate = useCustomNavigation();
  const [userId, setUserId] = useState(user?.uid);
  const [supporter, setSupporter] = useState(false);

  useEffect(() => {
    CurrentSession.load().then((loadedUser: any) => {
      setUserId(loadedUser?.uid);
      setSupporter(loadedUser?.supporter || false);
    });
  }, [user]);

  return (
    <Button
      onClick={() => {
        navigate("profile");
      }}
      sx={{ my: 1, mx: 0, p: 0 }}
    >
      <ProfilePicture
        uid={userId ?? ""}
        supporter={userId ? supporter : false}
        sx={{
          height: 60,
          width: 60,
        }}
      />
      <Typography
        color="warning.dark"
        className="logo-text"
        sx={{
          display: { xs: "none", sm: "block" },
          ml: 1,
          fontWeight: 500,
          fontSize: "1.5em",
        }}
      >
        Keep on
        <br />
        Tugging!
      </Typography>
    </Button>
  );
};

export default Logo;
